/*
|--------------------------------------------------------------------------
| site header module
|--------------------------------------------------------------------------
*/

/* ========================================================================== *\
IMPORTS
\* ========================================================================== */

import $ from 'jquery';

/* == END IMPORTS =========================================================== */

/* ========================================================================== *\
CONSTANTS
\* ========================================================================== */

const /**
   * The module name
   * @type {String}
   */
  moduleName = 'site-header',
  /**
   * Lookup table for selectors
   * @type {Object}
   */
  selectors = {
    base: 'js-' + moduleName,
    topNavLink: 'site-header__top-nav-link',
    closeFoldout: 'js-close-foldout',
    mainNavFoldout: moduleName + '__foldout',
    mainNavFoldoutSide: moduleName + '__foldout-side',
    mainNavFoldoutSubCatLink: moduleName + '__nav-list-item',
    mainNavLink: moduleName + '__main-nav-link',
    searchLink: moduleName + '__search-link',
    userPrefsLink: moduleName + '__user-prefs',
    userMenuLink: moduleName + '__user-menu-link',
    searchFoldout: moduleName + '__search',
    userPrefsFoldout: moduleName + '__control-panel',
    userMenuFoldout: moduleName + '__user-menu',
    mobileMenuToggle: 'js-mobile-menu-toggle',
    link: moduleName + '__link_wrapper',
    closeMenuSurfaceLink: moduleName + '__close-menu-surface',
    menuSurface: moduleName + '__menu-surface',
    menuOverlay: moduleName + '__overlay',
  },
  modifiers = {
    openModifier: '--is-open',
    activeModifier: '--is-active',
    mobileOpenModifier: '--mobile-is-open',
  },
  sitecoreEditMode = $('.sc-edit');

/* == END CONSTANTS ========================================================= */

/* ========================================================================== *\
SETUP site header
\* ========================================================================== */

/* == END SETUP site header ===================================================== */

/* ========================================================================== *\
EVENT HANDLING
\* ========================================================================== */

/**
 *
 * set active top navigation item
 */

const setActiveTopNav = () => {
  const subject = window.location.pathname.split('/')[1];
  const topnavs = document.querySelectorAll('.' + selectors.topNavLink);
  const selectedTopNav = Array.from(topnavs).find(
    (item) => item.textContent.toLowerCase() === subject
  );
  const adviseurTopNav = Array.from(topnavs).find(
    (item) => item.textContent.toLowerCase() === 'adviseur'
  );
  const zakelijkTopNav = Array.from(topnavs).find(
    (item) => item.textContent.toLowerCase() === 'zakelijk'
  );

  if (subject.length > 0 && selectedTopNav) {
    selectedTopNav.classList.add(
      selectors.topNavLink + modifiers.activeModifier
    );
  } else if (subject.length === 0 && !selectedTopNav && adviseurTopNav) {
    adviseurTopNav.classList.add(
      selectors.topNavLink + modifiers.activeModifier
    );
  } else if (zakelijkTopNav) {
    zakelijkTopNav.classList.add(
      selectors.topNavLink + modifiers.activeModifier
    );
  }
};

/**
 *
 * toggle menu foldout
 */
const toggleMenuFoldout = (e) => {
  let $element = $(e.currentTarget);

  if (!$element.data('foldoutCategory')) {
    return;
  }

  e.preventDefault();

  if ($element.hasClass(selectors.mainNavLink + modifiers.activeModifier)) {
    closeMenuFoldout();
  } else {
    openMenuFoldout($element);
  }
};

/**
 * close foldout
 */
const closeMenuFoldout = () => {
  if (
    !$('.' + selectors.base).hasClass(moduleName + modifiers.mobileOpenModifier)
  ) {
    if (
      $('.' + selectors.mainNavFoldout + modifiers.openModifier)
        .first()
        .hasClass(selectors.mainNavFoldout + modifiers.openModifier)
    ) {
      $('.' + selectors.mainNavFoldout + modifiers.openModifier).removeClass(
        selectors.mainNavFoldout + modifiers.openModifier
      );
      $('.' + moduleName + modifiers.openModifier).removeClass(
        moduleName + modifiers.openModifier
      );
      $('.' + selectors.mainNavLink).removeClass(
        selectors.mainNavLink + modifiers.activeModifier
      );
    }
    closeSearchFoldout();
  } else {
    // check if a side nav is open, otherwise close the nav item.
    if (
      $('.' + selectors.mainNavFoldoutSide + modifiers.openModifier).length <= 0
    ) {
      $('.' + selectors.mainNavFoldout + modifiers.openModifier).removeClass(
        selectors.mainNavFoldout + modifiers.openModifier
      );
      $('.' + moduleName + modifiers.openModifier).removeClass(
        moduleName + modifiers.openModifier
      );
      $('.' + selectors.mainNavLink).removeClass(
        selectors.mainNavLink + modifiers.activeModifier
      );
    }

    $('.' + selectors.mainNavFoldoutSide).removeClass(
      selectors.mainNavFoldoutSide + modifiers.openModifier
    );
  }
  $('.' + selectors.closeFoldout).blur();
};

const openMenuFoldout = ($element) => {
  let $selectedSelector = $element,
    selectedCategory = $selectedSelector.data('foldout-category'),
    selectedSubCategory = $selectedSelector.data('foldout-subcategory'),
    $foldoutWrapper = $(
      '.' +
        selectors.mainNavFoldout +
        '[data-foldout-category="' +
        selectedCategory +
        '"]'
    );

  // reset states
  $('.' + selectors.mainNavFoldout).removeClass(
    selectors.mainNavFoldout + modifiers.openModifier
  );
  $('.' + selectors.mainNavLink).removeClass(
    selectors.mainNavLink + modifiers.activeModifier
  );
  closeSearchFoldout();

  // set states
  $selectedSelector.addClass(selectors.mainNavLink + modifiers.activeModifier);
  $foldoutWrapper.addClass(selectors.mainNavFoldout + modifiers.openModifier);
  $('.' + moduleName).addClass(moduleName + modifiers.openModifier);

  // select category, do not autoselect for mobile, so check if we are in mobile navigation
  if (
    !$('.' + selectors.base).hasClass(moduleName + modifiers.mobileOpenModifier)
  ) {
    displayCategory($foldoutWrapper, selectedSubCategory);
  }
};

const showCategoryHover = (e) => {
  if (window.matchMedia('(min-width: 768px)').matches) {
    showCategory(e);
  }
};

const showCategory = (e) => {
  e.preventDefault();

  let $selectedSelector = $(e.currentTarget),
    $foldoutWrapper = $selectedSelector.closest('.' + selectors.mainNavFoldout),
    selectedSubCategory = $selectedSelector.data('foldout-subcategory');

  displayCategory($foldoutWrapper, selectedSubCategory);
};

const displayCategory = ($wrapper, selectedSubCategory) => {
  let $subCategory = $wrapper.find(
    '.' +
      selectors.mainNavFoldoutSide +
      '[data-foldout-subcategory="' +
      selectedSubCategory +
      '"]'
  );

  // reset states
  $('.' + selectors.mainNavFoldoutSide).removeClass(
    selectors.mainNavFoldoutSide + modifiers.openModifier
  );
  $wrapper
    .find('.' + selectors.mainNavFoldoutSubCatLink)
    .removeClass('nav-list__item' + modifiers.activeModifier);

  // set active states
  $wrapper
    .find(
      '.' +
        selectors.mainNavFoldoutSubCatLink +
        '[data-foldout-subcategory="' +
        selectedSubCategory +
        '"]'
    )
    .addClass('nav-list__item' + modifiers.activeModifier);
  $subCategory.addClass(selectors.mainNavFoldoutSide + modifiers.openModifier);
};

const toggleSearchFoldout = (e) => {
  e.preventDefault();

  if (
    $('.' + selectors.searchFoldout).hasClass(
      selectors.searchFoldout + modifiers.activeModifier
    )
  ) {
    closeSearchFoldout();
  } else {
    closeAllOpenMenus();
    openSearchFoldout();
  }
};

const openSearchFoldout = () => {
  closeMenuFoldout();
  $('.' + moduleName).addClass(moduleName + modifiers.openModifier);
  $('.' + selectors.searchFoldout).addClass(
    selectors.searchFoldout + modifiers.activeModifier
  );

  $('.' + selectors.searchFoldout + ' input:first').focus();
};

const closeSearchFoldout = () => {
  $('.' + moduleName).removeClass(moduleName + modifiers.openModifier);
  $('.' + selectors.searchFoldout).removeClass(
    selectors.searchFoldout + modifiers.activeModifier
  );

  $('.js-' + selectors.searchFoldout + '__input').blur();
};

const openUserPrefsFoldout = () => {
  $('.' + selectors.userPrefsLink).addClass(
    selectors.userPrefsLink + modifiers.activeModifier
  );
  $('.' + selectors.userPrefsFoldout).addClass(
    selectors.userPrefsFoldout + modifiers.openModifier
  );
};

const closeUserPrefsFoldout = () => {
  $('.' + selectors.userPrefsLink).removeClass(
    selectors.userPrefsLink + modifiers.activeModifier
  );
  $('.' + selectors.userPrefsFoldout).removeClass(
    selectors.userPrefsFoldout + modifiers.openModifier
  );
};

const toggleUserPrefsFoldout = () => {
  if (
    $('.' + selectors.userPrefsFoldout).hasClass(
      selectors.userPrefsFoldout + modifiers.openModifier
    )
  ) {
    closeUserPrefsFoldout();
  } else {
    closeAllOpenMenus();
    openUserPrefsFoldout();
  }
};

const toggleUserMenuFoldout = (e) => {
  e.preventDefault();
  if (
    $('.' + selectors.userMenuFoldout).hasClass(
      selectors.userMenuFoldout + modifiers.openModifier
    )
  ) {
    $('.' + selectors.userMenuFoldout).removeClass(
      selectors.userMenuFoldout + modifiers.openModifier
    );
  } else {
    closeAllOpenMenus();
    $('.' + selectors.userMenuFoldout).addClass(
      selectors.userMenuFoldout + modifiers.openModifier
    );
  }
};

const toggleMobileMenu = (e) => {
  e.preventDefault();
  if (
    $('.' + selectors.base).hasClass(moduleName + modifiers.mobileOpenModifier)
  ) {
    $(e.currentTarget).find('.toggle__hamburger').removeClass('is-active');
    closeMobileMenu();
  } else {
    closeAllOpenMenus();
    $(e.currentTarget).find('.toggle__hamburger').addClass('is-active');
    openMobileMenu();
  }
};

const openMobileMenu = () => {
  $('.' + selectors.base).addClass(moduleName + modifiers.mobileOpenModifier);
  $('body').addClass('site-header__noScroll');
};

const closeMobileMenu = () => {
  $('.' + selectors.base).removeClass(
    moduleName + modifiers.mobileOpenModifier
  );
  $('body').removeClass('site-header__noScroll');
};

// open menu-surface
const toggleMenuSurface = (e) => {
  if (
    $(e.target).hasClass(selectors.menuSurface) ||
    $(e.target).closest('.' + selectors.menuSurface).length > 0
  ) {
    return;
  }

  const targetMenuElement = $(e.target)
    .closest('.' + selectors.link)
    .find('.' + selectors.menuSurface);

  if (
    targetMenuElement.hasClass(selectors.menuSurface + modifiers.openModifier)
  ) {
    $('.' + selectors.menuSurface).removeClass(
      selectors.menuSurface + modifiers.openModifier
    );
    $('.' + selectors.menuOverlay).removeClass(
      selectors.menuOverlay + '--menu-surface'
    );
  } else {
    closeAllOpenMenus();
    $('.' + selectors.menuSurface).removeClass(
      selectors.menuSurface + modifiers.openModifier
    );
    $('.' + selectors.menuOverlay).addClass(
      selectors.menuOverlay + '--menu-surface'
    );
    targetMenuElement.addClass(selectors.menuSurface + modifiers.openModifier);
  }
};

// close menu-surface
const closeMenuSurface = (e) => {
  $('.' + selectors.menuSurface).removeClass(
    selectors.menuSurface + modifiers.openModifier
  );
  $('.' + selectors.menuOverlay).removeClass(
    selectors.menuOverlay + '--menu-surface'
  );
};

const closeAllOpenMenus = () => {
  closeMenuFoldout();
  closeMenuSurface();
  closeMobileMenu();
  closeSearchFoldout();
  closeUserPrefsFoldout();
};

const bindHandlers = () => {
  $('.' + selectors.closeFoldout).on('click', closeMenuFoldout);
  $('.' + selectors.mainNavLink).on('click', toggleMenuFoldout);
  $('.' + selectors.mainNavFoldoutSubCatLink).on(
    'mouseover',
    showCategoryHover
  );
  $('.' + selectors.mainNavFoldoutSubCatLink).on('click', showCategory);
  $('.' + selectors.searchLink).on('click', toggleSearchFoldout);
  $('.' + selectors.userPrefsLink).on('click', toggleUserPrefsFoldout);
  $('.' + selectors.userMenuLink).on('click', toggleUserMenuFoldout);
  $('.' + selectors.mobileMenuToggle).on('click', toggleMobileMenu);
  $('.' + selectors.link).on('click', toggleMenuSurface);
  $('.' + selectors.menuOverlay).on('click', closeMenuFoldout);
  $('.' + selectors.menuOverlay).on('click', closeMenuSurface);
  $('.' + selectors.closeMenuSurfaceLink).on('click', closeMenuSurface);
};

/* == END EVENT HANDLING ==================================================== */

/* ========================================================================== *\
INITIALIZATION
\* ========================================================================== */

/**
 * Initialize site-header module
 */
function init() {
  bindHandlers();
  setActiveTopNav();
}

if (document.getElementsByClassName('.' + selectors.base)) {
  init();
}

/* == END INITIALIZATION ==================================================== */

/* ========================================================================== *\
EXPORTS
\* ========================================================================== */

// No exports, just default behaviour

/* == END EXPORTS ====================================================== */
